import { writable } from 'svelte/store';
import type { MapLayerOneType } from '../../utilities/MapLayer/MapLayerApi';

export let MapLegendStoreX = writable<number>(100);
export let MapLegendStoreZoom = writable<number>(1);
export let MapLegendLayers = writable<MapLayerOneType[]>([]);
export let MapLegendLayersActive = writable<string[]>([]);
